import styled from 'styled-components'

export const PagePrimaryButton = styled.button`
  height: 38px;
  border: 1px solid #25384c;
  background: #25384c;
  color: #fff;
  border-radius: 4px;
  min-width: 88px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
`

export const PageSecondaryButton = styled.button`
  height: 34px;
  border: 1px solid #bec8d3;
  background: #f0f3f6;
  color: #41576d;
  border-radius: 4px;
  min-width: 88px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
`

export const PageDangerButton = styled.button`
  height: 34px;
  border: 1px solid #b42318;
  background: #fff2f1;
  color: #b42318;
  border-radius: 4px;
  min-width: 140px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
`

export const PageActionButton = styled.button`
  border: 0;
  background: transparent;
  color: #25384c;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  text-transform: uppercase;
`
